export const URL_API = 'http://localhost:7001'

export const URL_IMG = 'http://localhost:4700/api/v1/web/days'
